// Router configuration
import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';

// Views
import HomeView from '../views/HomeView.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: () => import('../views/FavoritesView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { guest: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { guest: true },
  },
  {
    path: '/admin/upload',
    name: 'admin-upload',
    component: () => import('../views/AdminUploadView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/admin/manage',
    name: 'admin-manage',
    component: () => import('../views/AdminManageView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  // Catch-all redirect to home
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

// Navigation guards
router.beforeEach((to, _from, next) => {
  // Check if user data exists in localStorage (persisted by Pinia)
  const authData = localStorage.getItem('tamil-soundboard-auth');
  let isAuthenticated = false;
  let isAdmin = false;

  if (authData) {
    try {
      const parsed = JSON.parse(authData);
      isAuthenticated = !!parsed.user;
      isAdmin = parsed.user?.is_admin ?? false;
    } catch {
      // Invalid data
    }
  }

  // Check route requirements
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } });
    return;
  }

  if (to.meta.requiresAdmin && !isAdmin) {
    next({ name: 'home' });
    return;
  }

  if (to.meta.guest && isAuthenticated) {
    next({ name: 'home' });
    return;
  }

  next();
});

export default router;
